import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";
import { useMessagesStore } from "../store";

export const createTemplate = ({ churchId, templateData }) => {
  return axios.post(`/churches/${churchId}/message-templates`, templateData);
};

export const useCreateTemplate = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const closeCreateTemplateModal =
    useMessagesStore.getState().closeCreateTemplateModal;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("templates");
      setNotification({
        type: "success",
        message: "Template created successfully!"
      });
      closeCreateTemplateModal();
    },
    ...config,
    mutationFn: createTemplate
  });
};
